'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = require('./components/IconButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/icon/index.js
// module id = 430
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 15